import { atom } from 'jotai';

import { GalaxySidebarSwitchTabIndex, MarsSidebarSwitchTabIndex } from '@/types/nav';

export const galaxySidebarSwitchTabIndexAtom = atom<GalaxySidebarSwitchTabIndex>(GalaxySidebarSwitchTabIndex.Live);

export const marsSidebarSwitchTabIndexAtom = atom<MarsSidebarSwitchTabIndex>(MarsSidebarSwitchTabIndex.Sports);